module.exports = __webpack_public_path__ + "img/about-ch2-problems-megacities.8f5976a5.png";